import React from "react";
import "./Cylinder.css";

interface CylinderItem {
  id: number;
  value: string;
  text: string;
}

interface CylinderProps {
  items: CylinderItem[];
}

export default function Cylinder({ items }: CylinderProps) {
  return (
    <section className="cylinder-section">
      <div className="cylinder-container">
        {items.map((item) => (
          <div key={item.id} className="cylinder-card">
            <h2 className="cylinder-value">{item.value}</h2>
            <p className="cylinder-text">{item.text}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
